import { useEffect } from "react"
import { useQueryClient } from "@tanstack/react-query"

import SuccessfulActionModalBody from "#/shared/components/modals/SuccessfulActionModalBody"
import { queryKeysFactory } from "#/shared/constants"
import { bigIntToHumanReadableFormat, floatToBigInt } from "#/shared/utils"
import { ComponentStepProps, useStepperModalContext } from "#/ui/Modal"

import { StakingFormValue } from "../components"

export default function SuccessfullyStakedStep({
  onClickContinue,
}: ComponentStepProps) {
  const {
    values: { amount },
  } = useStepperModalContext<StakingFormValue>()

  const queryClient = useQueryClient()

  useEffect(
    () => () => {
      queryClient.invalidateQueries({
        queryKey: queryKeysFactory.userKeys.stakes(),
        refetchType: "all",
      })

      queryClient.invalidateQueries({
        queryKey: queryKeysFactory.mezoKeys.stakingStats(),
        refetchType: "all",
      })
    },
    [queryClient],
  )

  return (
    <SuccessfulActionModalBody
      title={`${bigIntToHumanReadableFormat(floatToBigInt(amount))} BTC`}
      description="Congratulations on staking! Your veBTC will be in your wallet soon."
      onClickContinue={onClickContinue}
      // TODO: Change to `Claim rewards` rewards once we add support for
      // calculating/claiming rewards.
      nextStepButtonLabel="Done"
    />
  )
}
